var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChallenges({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15l-2 5h4l-2-5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 21h8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3h12v4a6 6 0 01-12 0V3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3H4a1 1 0 00-1 1v1a3 3 0 003 3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3h2a1 1 0 011 1v1a3 3 0 01-3 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallenges);
export default __webpack_public_path__ + "static/media/challenges.6586f1c2.svg";
export { ForwardRef as ReactComponent };